import { Component, EventEmitter, OnInit, Output,inject,signal } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { Util } from 'src/app/utils/utils';
import { RedesSocialesService } from '../../services/redes-sociales/redes-sociales.service';
import { QRCodeComponent } from 'angularx-qrcode'; // Si instalaste angularx-qrcode
import { WhatsappService, WhatsappMessage, WhatsappStatus } from 'src/app/base/services/whatsapp/whatsapp.service';
import { Subscription } from 'rxjs';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';

declare const qr:any

@Component({
    selector: 'app-whatsapp-configuracion',
    standalone: true,
    imports: [CommonModule, QRCodeComponent], // Agrega QRCodeComponent si lo instalaste
    templateUrl: './whatsapp-configuracion.component.html',
    styleUrls: ['./whatsapp-configuracion.component.css']
})
export class WhatsappConfiguracionComponent extends BaseComponent implements OnInit {
  private whatsappService = inject(WhatsappService);
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();

  codigo_qr:string;
  sucursales_usuario:any[]=[];
  empresa:any;

  // Usamos Angular Signals para un manejo de estado moderno y reactivo en el template
  public status = signal<WhatsappStatus>({ status: 'desconectado', qr: null });
  public mensajes = signal<WhatsappMessage[]>([]);

  private subs = new Subscription();

  constructor(public persistenciaService:PersistenciaService,
    public generalService:GeneralService,
    private socket: Socket,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public usuarioService:UsuarioService,
    public redesSocialesService:RedesSocialesService) {
    super(persistenciaService,modalService,generalService,usuarioService);
  }

  ngOnInit(): void {
    /*this.empresa.codigo_qr=null;
    let me=this;
    this.socket.on('enviarCodigoQrSucursal', (dato) => { console.log(dato);
      //me.blockUI.start();
      if(me.usuario.empresa.id==dato.id_empresa){
        this.empresa.codigo_qr=dato.qr;
      }
      //me.blockUI.stop();
    });

    this.socket.on('clienteIniciado', (dato) => { console.log(dato);
      if(dato.id_empresa==me.usuario.empresa.id){
        me.usuario.empresa.conexion_redes_sociales=dato.uid;
        me.persistenciaService.set("uid_empresa_whatsapp_"+dato.id_empresa,dato.uid);
        me.toastr.success(dato.mensaje);
        me.alTerminar.emit(dato);
      }
    });

    this.socket.on('enviarChatWhatsapp', (dato) => { console.log(dato);
      this.alTerminar.emit(dato);
    });

    this.conectarClienteWhtasapp();*/

    // 1. Nos conectamos al Socket específico de nuestra empresa
    this.whatsappService.conectarEmpresaSocket(this.usuario.id_empresa);

    // 2. Nos suscribimos al estado de la conexión de WhatsApp (Status y QR)
    this.subs.add(
      this.whatsappService.status$.subscribe(newStatus => {
        this.status.set(newStatus);
      })
    );

    // 3. Nos suscribimos al flujo de mensajes entrantes
    this.subs.add(
      this.whatsappService.messages$.subscribe(newMsg => {
        // Añadimos el nuevo mensaje al inicio del array
        this.mensajes.update(prev => [newMsg, ...prev]);
      })
    );
  }

  conectarClienteWhtasapp(){
    this.blockUI.start();
    this.redesSocialesService.solicitarConexionClienteWhatsapp({id_empresa:this.usuario.id_empresa}).subscribe((res:any)=>{
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
    });
  }

  cerrarComponente(){
    this.alTerminar.emit();
  }

/**
   * Disparador para iniciar el bot de WhatsApp en el backend
   */
  vincularWhatsApp(): void {
    // 1. Aseguramos que el socket esté conectado y en la sala primero
    this.whatsappService.conectarEmpresaSocket(this.usuario.id_empresa);

    // 2. Damos un pequeño margen de milisegundos para que el servidor registre la sala
    setTimeout(() => {
      this.whatsappService.solicitarConexionExpress(this.usuario.id_empresa).subscribe({
        next: (res) => console.log('Instancia de Baileys solicitada con éxito'),
        error: (err) => console.error('Error al conectar:', err)
      });
    }, 300); // 300ms de gracia garantizan que Socket.io ya procesó el 'join_session'

  }

  abrirPopupConfirmacionEliminacion(){
      this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
      this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de eliminar la vicnulacion de la cuenta de whatsapp?";
      
      this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
        if($e.confirm){
          this.desvincularWhatsApp();
        }
        this.popupConfirmacion.close();
          });
  }

  /**
   * Disparador para desvincular la cuenta y borrar los archivos del server
   */
  desvincularWhatsApp(): void {
    if (confirm('¿Estás seguro de que deseas desvincular tu WhatsApp?')) {
      this.whatsappService.solicitarDesvinculacionExpress(this.usuario.id_empresa).subscribe({
        next: (res) => {
          alert('Cuenta desvinculada con éxito');
          this.mensajes.set([]); // Limpiamos la vista local
        },
        error: (err) => console.error('Error al desvincular:', err)
      });
    }
  }

  ngOnDestroy(): void {
    // Evitamos memory leaks cancelando suscripciones y cerrando el socket de esta vista
    this.subs.unsubscribe();
    this.whatsappService.desconectarSocket();
  }

}
